export const formatPhoneNumber = (phone) => {
  if (phone && phone.length === 10) {
    phone = phone.replace(/\D+/g, '')
                 .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  } else {
    phone = "-"
  }
  return phone;
}

export const getAppBasePath = () => {
  let baseURL = window?.location.origin + "/#/login";
  console.log("baseURL:", baseURL);
  return baseURL;
}
